import { css, extractTransition, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    width: 100%;
    height: 100%;

    ${extractTransition((f) => f.cubic, { duration: 330, property: 'opacity' })}
  `,
  skeleton: css`
    background-color: white;
    z-index: 1;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
